import { useMap } from "react-leaflet";
import { useTrafficMessages } from "../../../stores/MapLayers/TrafficMessagesStore";
import React from "react";
import { TrafficMessageLineMarker } from "./TrafficMessageLineMarker";
import { TrafficMessagePointMarker } from "./TrafficMessagePointMarker";
import L from "leaflet";
import trafficMessageResource from "../../../assets/roadworksIcon.svg"
import { GeoJsonFeature } from "../../../services/OgcService/models/GeoJsonFeature";
import { SituationProperties } from "../../../services/OgcService/models/SituationFeatureCollection";
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const trafficMessageIcon = () => L.divIcon({
    className: ".height-restriction-header-icon-wrapper",
    html: '<img style="height: 35px; width: 35px;" src="' + trafficMessageResource + '" />',
    iconAnchor: [17, 35]
})

export function TrafficMessages() {
    const [ displayPolyline, setDisplayPolyLine ] = React.useState(false);
    const trafficMessages = useTrafficMessages();
    const map = useMap();
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();

    const onTrafficMessageClicked = (feature: GeoJsonFeature<SituationProperties>) => {
        setClickedRoadFeature(feature);
        setRoadFeatureDialogIsOpen(true);
    }

    map.on('zoomend', function() {
        if(map.getZoom() > 8){
            setDisplayPolyLine(true)
        }
        else{
            setDisplayPolyLine(false)
        }
    })

    return (
        <>
            {trafficMessages && trafficMessages.features.map((trafficMessage) => {
                return ( 
                    <div key={trafficMessage.id + "container"}>
                        <TrafficMessagePointMarker
                            key={trafficMessage.id + "point"} 
                            trafficMessage={trafficMessage} 
                            icon={trafficMessageIcon()} 
                            onTrafficMessageClicked={onTrafficMessageClicked}
                        />
                        <TrafficMessageLineMarker
                            key={trafficMessage.id + "line"}  
                            trafficMessage={trafficMessage} 
                            icon={trafficMessageIcon()} 
                            onTrafficMessageClicked={onTrafficMessageClicked} 
                            displayPolyline={displayPolyline} 
                        />
                    </div>
                )
            })
            }
        </>
    )
}

function GetLineCoordinates(coordinates : number[][]){
    return coordinates.map((coor) => {
        return L.latLng(coor[1], coor[0])
    })
} 

function GetMedianCoordinate(coordinates : number[][]){
    const median = Math.round(coordinates.length / 2);
    return coordinates[median];
} 